"use strict";
const ID = "focasos-cargando";
const DESCARGAS = /\.(pdf|odt|ods|csv|zip|docx?|xlsx?|pptx?|png|jpe?g|gif|svg|webp)$/i;
const RUTAS_DE_DESCARGA = /\/(descargar|hoja-de-trabajo)(\/|$)|\/rails\/active_storage\//;
const SEGUNDOS_MAXIMOS = 25;
const MILISEGUNDOS_HASTA_EL_AVISO = 600;
let raiz = null;
let aviso = null;
let estado = null;
let temporizadorAviso = null;
let temporizadorMaximo = null;
let ignorarHasta = 0;
const crear = () => {
  if (raiz) {
    return raiz;
  }
  raiz = document.createElement("div");
  raiz.id = ID;
  raiz.className = "focasos-cargando";
  raiz.hidden = true;
  raiz.innerHTML = [
    '<div class="focasos-cargando__barra" aria-hidden="true"></div>',
    '<div class="focasos-cargando__aviso" aria-hidden="true">Cargando\u2026</div>',
    '<div class="sr-only focasos-cargando__estado" role="status" aria-live="polite"></div>'
  ].join("");
  document.body.appendChild(raiz);
  aviso = raiz.querySelector(".focasos-cargando__aviso");
  estado = raiz.querySelector(".focasos-cargando__estado");
  return raiz;
};
const ocultar = () => {
  window.clearTimeout(temporizadorAviso);
  window.clearTimeout(temporizadorMaximo);
  if (!raiz) {
    return;
  }
  raiz.hidden = true;
  raiz.classList.remove("focasos-cargando--aviso");
  estado.textContent = "";
  document.documentElement.classList.remove("focasos-cargando-activo");
};
const mostrar = () => {
  crear();
  if (!raiz.hidden) {
    return;
  }
  raiz.hidden = false;
  document.documentElement.classList.add("focasos-cargando-activo");
  temporizadorAviso = window.setTimeout(() => {
    raiz.classList.add("focasos-cargando--aviso");
    estado.textContent = "Cargando la p\xE1gina\u2026";
  }, MILISEGUNDOS_HASTA_EL_AVISO);
  temporizadorMaximo = window.setTimeout(ocultar, SEGUNDOS_MAXIMOS * 1e3);
};
const esDescarga = (url) => DESCARGAS.test(url.pathname) || RUTAS_DE_DESCARGA.test(url.pathname);
const cambiaDePagina = (enlace) => {
  if (enlace.hasAttribute("download") || enlace.target && enlace.target !== "_self") {
    return false;
  }
  if (enlace.matches("[data-dialog-open], [data-controls], [data-toggle], [data-open], [data-close], [role='button'], [aria-haspopup]")) {
    return false;
  }
  let url = null;
  try {
    url = new URL(enlace.href, window.location.href);
  } catch (error) {
    return false;
  }
  if (!/^https?:$/.test(url.protocol)) {
    return false;
  }
  if (esDescarga(url)) {
    ignorarHasta = Date.now() + 3e3;
    return false;
  }
  return !(url.origin === window.location.origin && url.pathname === window.location.pathname && url.search === window.location.search && url.hash !== "");
};
const iniciar = () => {
  document.addEventListener("click", (evento) => {
    if (evento.button !== 0 || evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey) {
      return;
    }
    const enlace = evento.target.closest && evento.target.closest("a[href]");
    if (!enlace) {
      return;
    }
    window.setTimeout(() => {
      if (!evento.defaultPrevented && cambiaDePagina(enlace)) {
        mostrar();
      }
    }, 0);
  });
  document.addEventListener("submit", (evento) => {
    const formulario = evento.target;
    window.setTimeout(() => {
      if (evento.defaultPrevented || formulario.target && formulario.target !== "_self" || formulario.hasAttribute("data-remote")) {
        return;
      }
      mostrar();
    }, 0);
  });
  window.addEventListener("beforeunload", () => {
    if (Date.now() >= ignorarHasta) {
      mostrar();
    }
  });
  window.addEventListener("pageshow", ocultar);
};
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", iniciar);
} else {
  iniciar();
}
